import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

export type DocumentCentreSharesState = CommonTableState & {
    refetchIndicator: number;
};

const initialState: DocumentCentreSharesState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            miningStatus: false,
            description: false,
            modified: false,
            kind: false,
            created: false,
        },
        pagination: {
            pageIndex: 0,
            pageSize: 1000,
        },
        columnOrder: [
            "centre.id",
            "ratio",
            "partAmount",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
    refetchIndicator: 0,
};

export const documentCentreSharesSlice = createSlice({
    name: "documentCentreShares",
    initialState,
    reducers: {
        refetchDocumentCentreSharesTable: (state) => {
            state.refetchIndicator += 1;
        },
        updateDocumentCentreSharesTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateDocumentCentreSharesTableState, refetchDocumentCentreSharesTable } = documentCentreSharesSlice.actions;

export default documentCentreSharesSlice.reducer;
